import { useQuery } from "@tanstack/react-query";
import localforage from "localforage";
import { OrderFragment } from "./fragments/order";
import { STORAGE_KEYS } from "~/libs/storage-keys";
import { setState, useOrderId, useOrderRef } from "~/store";
import {
	GetOrderByIdDocument,
	GetOrderByIdQuery,
	GetOrderByPayWayRefDocument,
	GetOrderByPayWayRefQuery,
} from "~/types/__generated/gql/graphql";
import { State } from "~/types/store";
import { gqlReq } from "~/libs/gql";

void (
	/* GraphQL */ `
		query GetOrderByPayWayRef($ref: String!) {
			getOrderByPayWayRef(ref: $ref) {
				...OrderFragment
			}
		}
		${OrderFragment}
	`
);

void (
	/* GraphQL */ `
		query GetOrderById($id: ObjectID!) {
			getOrderById(id: $id) {
				...OrderFragment
			}
		}
		${OrderFragment}
	`
);

export type GetOrderResults =
	| GqlResultOf<GetOrderByPayWayRefQuery>
	| GqlResultOf<GetOrderByIdQuery>;

export const getOrderQueryKey = (key) => ["order", key];

export const useGetOrder = () => {
	const orderId = useOrderId();
	const orderRef = useOrderRef();

	return useQuery({
		enabled: !!orderId || !!orderRef,
		queryKey: getOrderQueryKey(orderId ?? orderRef),
		queryFn: ({ signal }) => {
			if (orderRef) {
				const variables = { ref: orderRef };
				return gqlReq({
					document: GetOrderByPayWayRefDocument,
					variables,
					signal,
				});
			}
			if (orderId) {
				const variables = { id: orderId };
				return gqlReq({
					document: GetOrderByIdDocument,
					variables,
					signal,
				});
			}
			return Promise.reject(new Error("No order to fetch"));
		},
		onSuccess: async (data) => {
			if (!data) return;
			const newState = {
				venueId: data.venue,
				locationId: data.location,
			} as State;
			if (data.device) {
				newState.deviceId = data.device;
				await localforage.setItem(STORAGE_KEYS.DEVICE_ID, data.device);
			}
			setState(newState);
		},
	});
};
